/**
 * Created by john on 7/17/15.
 */

'use strict';

const React = require('react');

/**
 * Adds the child context types from Fluxible.provideContext to the passed in props.
 * This is a convenience method to avoid having to type it on every child class that needs a context.
 * @param props {object} The properties that will be passed to React.createClass
 */
module.exports = (props) => {
    return Object.assign({}, props, {
        contextTypes: {
            getStore     : React.PropTypes.func.isRequired,
            executeAction: React.PropTypes.func.isRequired
        }
    });
};



// WEBPACK FOOTER //
// ./assets/js/global/reactHelpers/hasContextTypes.es.js